export const API_REQUEST_INITIATED = 'api/requestInitiated';
export const API_REQUEST_FINISHED = 'api/requestFinished';
export const API_ERROR_OCCURED = 'api/errorOccured';
export const API_ERROR_CLEARED = 'api/errorCleared';
export const API_BREEDS_FETCHED = 'api/breedsFetched';
export const APP_BREED_SELECTED = 'app/breedSelected';
